import React from 'react';
import { FreightForwarder, ChargeCode, Currency, Container } from '../../../types';
const FreightForwarderContext = React.createContext<{
  currentFreightForwarder: FreightForwarder | undefined;
  containers: Container[];
  updateFreightForwarder: (freightForwarder: FreightForwarder) => void;
  chargeCodes: ChargeCode[];
  currencies: Currency[];
  baseCurrencyCode: string;
}>({
  currentFreightForwarder: undefined,
  containers: [],
  updateFreightForwarder: () => {
    return;
  },
  chargeCodes: [],
  currencies: [],
  baseCurrencyCode: 'NZD',
});

export default FreightForwarderContext;
